import React from "react";
import { createPortal } from "react-dom";
import RedButton from "./RedButton";
import GreyOutlineButton from "./GreyOutlineButton";
import "./common.scss";
import GreenButton from "./GreenButton";

const ConfirmationPopup = ({
  handleNo,
  handleYes,
  heading,
  content,
  image,
}) => {
  return createPortal(
    <div className="popup-container" style={{ zIndex: 10001 }}>
      <div className="popup flex w-full max-w-[560px] flex-col items-center rounded-[20px] bg-white px-6 py-7 text-center shadow-[0_12px_36px_rgba(0,0,0,0.18)] sm:px-8 sm:py-8">
        {image ? (
          <img
            src={image}
            alt=""
            className="mb-4 h-[56px] w-[56px] object-contain sm:h-[64px] sm:w-[64px]"
          />
        ) : null}
        <div className="flex w-full max-w-[440px] flex-col items-center justify-center gap-2.5">
          <p className="text-[18px] sm:text-[20px] font-[500] font-poppins text-[#303030]">
            {heading}
          </p>
          <p className="w-full text-[13px] leading-[1.55] sm:text-[15px] font-[400] font-poppins text-[#8C8C8C] break-words">
            {content}
          </p>
        </div>
        <div className="mt-6 flex w-full flex-col items-center justify-center gap-3 sm:flex-row sm:gap-4">
          <GreyOutlineButton
            className="h-[48px] sm:h-[50px] w-full max-w-[150px] font-[500] drop-shadow-[0_4px_4px_rgba(0,0,0,0.05)]"
            label="No"
            onClick={handleNo}
          />
          <GreenButton
            className="h-[48px] sm:h-[50px] w-full max-w-[150px] font-[500] drop-shadow-[0_4px_4px_rgba(236,130,110,0.3)]"
            label="Yes"
            onClick={handleYes}
          />
        </div>
      </div>
    </div>,
    document.body
  );
};

export default ConfirmationPopup;
